import { useState } from "react";
import { IoMdClose } from "react-icons/io";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";
import nodeinstance from "../../../../nodeInstance";
import { useNavigate } from "react-router-dom";

export default function CreditNoteAmount({
  showPromptElement,
  setShowPromptElement,
  propData,
  differenceAmount,
  data,
}) {
  const [InvoiceSent, setInvoiceSent] = useState();
  const [file, setFile] = useState();
  const [receivedDate, setReceivedDate] = useState();
  const dispatch = useDispatch();
  const token = localStorage.getItem("nodeToken");
  const navigate = useNavigate();
  console.log("Data tpo be displayed here....", data);

  const submitHandler = async (e, fileData) => {
    console.log("Updated Data to be seen here in console.", data);

    e.preventDefault();
    if (differenceAmount === 0) {
      dispatch(
        setAppError({
          msg: "Credit note amount should be greater then 0",
        })
      );
      return;
    }

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("credit_note", Math.abs(differenceAmount));
      formData.append("credit_note_sent_date", InvoiceSent);
      formData.append("credit_note_received_date", receivedDate);
      formData.append("Employees", JSON.stringify(data));

      if (fileData) {
        // formData.append("file", file);

        const response = await nodeinstance.put(
          `/dashboard/invoiceCostPlus/upload/${propData && propData?.data[0].invoice_no}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (response.status === 200) {
          setShowPromptElement(false);
          dispatch(
            setAppError({
              msg: "Successfully uploaded.",
              color: "success",
            })
          );
          navigate("/dashboard/invoice-cost-plus");
        }

        console.log("success to be seen here......", response);
      }
    } catch (err) {
      console.log("error", err);
    }
  };
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          showPromptElement ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setShowPromptElement(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <form onSubmit={(e) => submitHandler(e, file)} className="w-full">
            <div className="w-full flex flex-col gap-3 my-3 p-5">
              <div className="flex flex-col p-2 gap-1 w-full max-w-md">
                <label htmlFor={`addOrEdit-name`} className="text-xs ">
                  INVOICE SENT DATE
                </label>
                <input
                  type="Date"
                  value={InvoiceSent}
                  className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                  onChange={(e) => {
                    setInvoiceSent(e.target.value);
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>
              <div className="flex flex-col p-2 gap-1 w-full max-w-md">
                <label htmlFor={`addOrEdit-name`} className="text-xs ">
                  INVOICE NUMBER
                </label>
                <input
                  className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                  // onChange={handleAmountChange}
                  value={propData && propData?.data[0].invoice_no}
                  disabled
                />
              </div>
              <div className="flex flex-col p-2 gap-1 w-full max-w-md">
                <label htmlFor={`addOrEdit-name`} className="text-xs ">
                  CREDIT NOTE AMOUNT
                </label>
                <input
                  className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                  // onChange={handleAmountChange}
                  value={Math.abs(differenceAmount)}
                  disabled
                />
              </div>
              <div className="flex flex-col p-2 gap-1 w-full max-w-md">
                <label htmlFor={`addOrEdit-name`} className="text-xs ">
                  REFERENCE NUMBER
                </label>
                <input
                  className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                  // onChange={handleAmountChange}
                  value={propData && propData?.data[0].reference_number}
                  // disabled
                />
              </div>
              <div className="flex flex-col p-2 gap-1 w-full max-w-md">
                <label htmlFor={`addOrEdit-name`} className="text-xs ">
                  RECEIVED DATE
                </label>
                <input
                  type="Date"
                  value={receivedDate}
                  className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                  onChange={(e) => {
                    setReceivedDate(e.target.value);
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>
              <div className="form-control w-full ">
                <label className="label">
                  <span className="label-text">Upload File</span>
                </label>
                <input
                  type="file"
                  className="file-input file-input-bordered w-full "
                  onChange={(e) => setFile(e.target.files[0])}
                  required
                  accept="image/*, application/doc, application/docx, application/pdf, application/xls, application/xlsx"
                />
              </div>
              <div
                className="flex gap-3 w-full justify-center"
                style={{ m: 2 }}
              >
                <button
                  type="submit"
                  className="p-2 bg-red text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center"
                >
                  {" "}
                  <p>Submit</p>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
